import { AccountingMigrationExternalSystem } from "@common/types/domains/accounting/accountingMigration";

export const SUPPORTED_MIGRATION_SYSTEMS: ReadonlyArray<AccountingMigrationExternalSystem | null> =
    [
        AccountingMigrationExternalSystem.QUICKBOOKS_ONLINE,
        AccountingMigrationExternalSystem.QUICKBOOKS_ONLINE_GL_COA,
        AccountingMigrationExternalSystem.QUICKBOOKS_DESKTOP,
        AccountingMigrationExternalSystem.XERO,
    ];
